import React from "react";
import DATA from "../data/data.json";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Principais Serviços</h2>
          {/* <p>Conheça nossos principais serviços</p> */}
        </div>
        <div className="row">
          {DATA.Services
            ? DATA.Services.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-4 card card-height3"
                >
                  {" "}
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
        <div className="row">
          {DATA.Services2
            ? DATA.Services2.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-4 card card-height2"
                >
                  {" "}
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
        <div className="row card2">
          {DATA.Services3
            ? DATA.Services3.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 card card3">
                  {" "}
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
